import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import NestedGridColumns from './NestedGridColumns';
import ClientProvider from './client';
export default createDemo(import.meta.url, NestedGridColumns, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/grid/demos/nested-columns/NestedGridColumns.tsx",
    "fileName": "NestedGridColumns.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Paper from '@mui/material/Paper';\nimport Grid from '@mui/material/Grid';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  color: (theme.vars ?? theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function NestedGridColumns() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Grid container spacing={2} columns={24}>\n        <Grid size={8}>\n          <Item>size=8/24</Item>\n        </Grid>\n        <Grid container size={16}>\n          <Grid size={12}>\n            <Item>nested size=12/24</Item>\n          </Grid>\n          <Grid size={12}>\n            <Item>nested size=12/24</Item>\n          </Grid>\n        </Grid>\n        <Grid size={8}>\n          <Item>size=8/24</Item>\n        </Grid>\n        <Grid container columns={12} size={16}>\n          <Grid size={6}>\n            <Item>nested size=6/12</Item>\n          </Grid>\n          <Grid size={6}>\n            <Item>nested size=6/12</Item>\n          </Grid>\n        </Grid>\n      </Grid>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 46,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Paper from '@mui/material/Paper';\nimport Grid from '@mui/material/Grid';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  color: (theme.vars ?? theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function NestedGridColumns() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Grid container spacing={2} columns={24}>\n        <Grid size={8}>\n          <Item>size=8/24</Item>\n        </Grid>\n        <Grid container size={16}>\n          <Grid size={12}>\n            <Item>nested size=12/24</Item>\n          </Grid>\n          <Grid size={12}>\n            <Item>nested size=12/24</Item>\n          </Grid>\n        </Grid>\n        <Grid size={8}>\n          <Item>size=8/24</Item>\n        </Grid>\n        <Grid container columns={12} size={16}>\n          <Grid size={6}>\n            <Item>nested size=6/12</Item>\n          </Grid>\n          <Grid size={6}>\n            <Item>nested size=6/12</Item>\n          </Grid>\n        </Grid>\n      </Grid>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 46,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Box",
      "@mui/material/Paper",
      "@mui/material/Grid"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
